import { Link } from "react-router-dom";
import { ArrowRight, Theater, Users, Calendar, MapPin, Phone, Mail, Sparkles } from "lucide-react";
import PageHero from "../components/PageHero";
import { SCHOOL } from "../lib/site";

const POSTER = "https://customer-assets-0z36b82j.emergentagent.net/job_music-academy-portal-2/artifacts/a625496640883ec0_da45d9f2-b0f0-47f2-b45a-2e72a68b2934.jpg";

export default function Teatro() {
  return (
    <div data-testid="page-teatro">
      <PageHero
        eyebrow="Amici per la Musica APS presenta · Trinity Musical School"
        title="The Dream Factory"
        italic="Portraits."
        subtitle="Corso di Teatro - Musical · recitazione. Costruiamo il vostro spettacolo, ispirato ai più famosi musical."
      />

      <section className="py-20 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <img
              src={POSTER}
              alt="The Dream Factory · Portraits — Corso di Teatro-Musical"
              data-testid="teatro-poster"
              className="w-full h-auto border border-[#A3133A]/15 shadow-xl"
            />
          </div>

          <div className="lg:col-span-7">
            <div className="text-[11px] tracking-eyebrow text-[#A3133A] mb-5">Corso di Teatro - Musical · Iscrizioni aperte</div>
            <h2 className="font-serif-display text-3xl md:text-4xl text-[#1C1C1C] leading-tight mb-6">
              Costruiamo il vostro spettacolo, <em className="italic font-light">ispirato ai più famosi musical.</em>
            </h2>
            <p className="text-[#5C5C5C] leading-relaxed mb-10">
              Recitazione, canto e movimento scenico si incontrano in un percorso che porta ogni gruppo
              a costruire un vero spettacolo in stile musical, dal primo passo fino al palco.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#A3133A]/15 border border-[#A3133A]/15 mb-10">
              <div className="bg-[#FBFBF9] p-8" data-testid="teatro-kids-teens">
                <Sparkles size={24} className="text-[#A3133A] mb-4" />
                <div className="text-[10px] tracking-eyebrow text-[#A3133A] mb-2">Giovani</div>
                <h3 className="font-serif-display text-2xl text-[#1C1C1C] mb-3">Kids &amp; Teens</h3>
                <p className="text-sm text-[#5C5C5C] leading-relaxed">
                  Bambini e ragazzi. Un palco su misura per crescere suonando, cantando, recitando e ballando.
                </p>
              </div>
              <div className="bg-[#FBFBF9] p-8" data-testid="teatro-adulti">
                <Users size={24} className="text-[#A3133A] mb-4" />
                <div className="text-[10px] tracking-eyebrow text-[#A3133A] mb-2">Adulti</div>
                <h3 className="font-serif-display text-2xl text-[#1C1C1C] mb-3">Adulti / Principianti</h3>
                <p className="text-sm text-[#5C5C5C] leading-relaxed">
                  Nessuna esperienza richiesta. Riscopri la scena a qualsiasi età, dal primo passo.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-4 mb-10 text-[#1C1C1C]">
              <div className="flex items-start gap-3" data-testid="teatro-periodo">
                <Calendar size={18} className="text-[#A3133A] mt-0.5 shrink-0" />
                <div>
                  <span className="text-[10px] tracking-eyebrow text-[#A3133A] block">Periodo</span>
                  <span className="text-sm">Da Ottobre a Maggio · ogni mercoledì</span>
                </div>
              </div>
              <div className="flex items-start gap-3" data-testid="teatro-sede">
                <MapPin size={18} className="text-[#A3133A] mt-0.5 shrink-0" />
                <div>
                  <span className="text-[10px] tracking-eyebrow text-[#A3133A] block">Sede</span>
                  <span className="text-sm">Rovigo · Via Luigi Einaudi 16 (Area Tosi)</span>
                </div>
              </div>
              <div className="flex items-start gap-3" data-testid="teatro-contatti">
                <Phone size={18} className="text-[#A3133A] mt-0.5 shrink-0" />
                <div>
                  <span className="text-[10px] tracking-eyebrow text-[#A3133A] block">Info &amp; Iscrizioni</span>
                  <span className="text-sm">0425 166 6483 · 391 308 47 61</span>
                </div>
              </div>
              <div className="flex items-start gap-3" data-testid="teatro-email">
                <Mail size={18} className="text-[#A3133A] mt-0.5 shrink-0" />
                <div>
                  <span className="text-[10px] tracking-eyebrow text-[#A3133A] block">Email</span>
                  <a href={`mailto:${SCHOOL.email}`} className="text-sm link-underline text-[#A3133A]">{SCHOOL.email}</a>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link
                to="/iscrizione?corso=teatro"
                data-testid="teatro-iscriviti-cta"
                className="bg-[#A3133A] text-white px-8 py-4 text-[12px] tracking-eyebrow rounded-sm hover:bg-[#8B0F2F] transition inline-flex items-center gap-2"
              >
                <Theater size={14} /> Iscriviti al corso di Teatro
              </Link>
              <Link
                to="/corsi"
                data-testid="teatro-vai-musica"
                className="border border-[#A3133A] text-[#A3133A] px-8 py-4 text-[12px] tracking-eyebrow rounded-sm hover:bg-[#A3133A] hover:text-white transition inline-flex items-center gap-2"
              >
                Corsi di Musica <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#A3133A] grain text-[#FBFBF9] py-16 px-6 md:px-12 lg:px-24">
        <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <div className="text-[11px] tracking-eyebrow opacity-80 mb-2">Corso di Teatro - Musical</div>
            <h2 className="font-serif-display text-3xl md:text-4xl leading-tight">
              Iscrizioni aperte — <em className="italic font-light">ogni mercoledì.</em>
            </h2>
          </div>
          <Link
            to="/iscrizione?corso=teatro"
            data-testid="teatro-banner-cta"
            className="bg-[#FBFBF9] text-[#A3133A] px-8 py-4 text-[12px] tracking-eyebrow rounded-sm hover:bg-white transition inline-flex items-center gap-2 self-start md:self-auto"
          >
            Prenota il tuo posto <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
}
